import { useEffect } from "react";
import { getBrand } from "../brand";

// public/index.html ships with PhonePlay's title, icons and manifest because
// one build serves both brands. This swaps them for the brand that matches
// the hostname as soon as the app mounts.
const setLink = (selector, rel, href, attrs = {}) => {
  let link = document.querySelector(selector);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
    document.head.appendChild(link);
  }
  link.href = href;
};

const setMeta = (name, content) => {
  let meta = document.querySelector(`meta[name='${name}']`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
};

const DynamicMeta = () => {
  useEffect(() => {
    const brand = getBrand();

    document.title = brand.name;
    setMeta("description", brand.description);
    setMeta("apple-mobile-web-app-title", brand.name);

    setLink("link[rel~='icon']", "icon", brand.favicon);
    setLink(
      "link[rel='apple-touch-icon']:not([sizes])",
      "apple-touch-icon",
      brand.appleTouchIcon
    );
    setLink(
      "link[rel='apple-touch-icon'][sizes='180x180']",
      "apple-touch-icon",
      brand.appleTouchIcon,
      { sizes: "180x180" }
    );
    setLink("link[rel='manifest']", "manifest", brand.manifest);
  }, []);

  return null;
};

export default DynamicMeta;
